export default __webpack_public_path__ + "static/media/fire_extinguisher.f78d7c45.svg";